<style scoped>
  #create-link {
    display: grid;
    grid-template-areas:
      "text balance"
      "links links";
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 10px;
  }

  @media all and (max-width: 1000px) {
    #create-link {
      grid-template-areas: "text" "balance" "links";
      grid-template-columns: 1fr;
    }
  }
  .create-link-text {
    /*width: 100%;*/
    /*float: left;*/
    padding-right: 100px;
    font-size: 16px;
    /*border: 1px solid black;*/
    /*box-sizing: border-box;*/
    grid-area: text;
  }

  .amount {
    /*color: var(--color-success-light);*/
    font-size: 20px;
    margin-left: 10px;
  }

  .free-ref-bal {
    font-size: 18px;
    color: var(--color-text-dark);
    /*margin-left: 20px;*/
  }

  .ref-table {
    padding: 10px;
    border-collapse: collapse;
    /*border-spacing: 20px;*/
    width: 100%;
  }

  .ref-table-row {
    /*border-bottom: 1px solid var(--color-border);*/
    padding: 10px;
    text-align: left;
    font-size: 16px;
  }

  .ref-table-header {
    border-bottom: 1px solid var(--color-border);
    padding: 10px;
    text-align: left;
    font-size: 14px;
  }

  .box1 {
    padding-top: 20px;
    padding-bottom: 30px;
    padding-left: 20px;
    /*margin-top: 10px;*/
    text-align: left;
  }

  .ref-input-error {
    font-size: 14px;
    color:var(--color-danger-light);
    margin-bottom: 0px;
    margin-top: 10px;
    height: 30px;
  }

  .create-link-box {
    padding-left: 20px;
    padding-right: 20px;
    grid-area: balance;
  }

  .infocell {
    width: 50%;
    vertical-align: top;
  }

  .tablerow {
    background-color: var(--color-card-dark);
    height: 32px;
    cursor: pointer;
  }

  .oddrow {
    background-color: var(--color-card);
  }

  .last-ref-table-row {
    border-top: 1px solid var(--color-border);
  }

  .linkslist {
    grid-area: links;
  }

  /*p {*/
  /*  border: 1px solid lightblue;*/
  /*}*/

  /*div {*/
  /*  border: 1px solid pink;*/
  /*}*/

  /*td {*/
  /*  border: 1px solid var(--color-success-light);*/
  /*}*/

  a:hover {
    text-decoration: underline;
  }
</style>

<template>
  <div>
    <Confirm :show="deleteModal" :text="$text.tr('Удалить ссылку') + ' ' + confirm.deleteId + '?'" :btname="$text.tr('УДАЛИТЬ')" @on-cancel="deleteModal = false"  @confirmed="deleteLink(confirm.deleteId)"/>
    <div id="create-link">
        <div class="box box1 create-link-text">
          <p style="font-size: 18px; color: var(--color-text-dark);">{{ $text.tr('РЕФЕРАЛЬНАЯ ПРОГРАММА') }}</p><br>
          <p>
            <b>{{ $text.tr('Зарабатывайте вместе с нами:') }}</b><br>
            {{ $text.tr('1. Создайте реферальную ссылку') }}<br>
            {{ $text.tr('2. Поделитесь ей с друзьями') }}
          </p>
          <br>
          <p>{{ $text.tr('- Все, кто зарегистрируется по вашей ссылке, получат скидку 15% на все платежи в течение 14 дней') }}<br>
            {{ $text.tr('- Bы будете зарабатывать 15% со всех платежей ваших рефералов') }}</p>
          <br>
          <p style="font-size: 14px">{{ $text.tr('Принимая участие, вы соглашаетесь с условиями') }}
            <a :href="referralAgreementLink" target="_blank" style="color: var(--color-text)">{{ $text.tr('Реферального соглашения') }}</a></p>
        </div>
        <div class="box box1 create-link-box">
          <span class="free-ref-bal">{{ $text.tr('БАЛАНС') }} </span>
          <span class="amount">${{ refBalance }}</span><br><br>
          <p class="ref-input-error" >{{ refInputError }}</p>
          <Tooltip :content="fullLink" placement="right" :disabled="!showTooltip" :always="showTooltip">
            <i-input v-model="linkId" type="text" size="large" style="width: 340px; margin-top: 0px;"
                     :placeholder="$text.tr('Придумайте ссылку')" :maxlength="25"></i-input>
          </Tooltip>
          <br>
          <i-input v-model="linkDesc" type="text" size="large"
                   style="width: 340px; margin-top: 10px;"
                   :placeholder="$text.tr('Описание')" :maxlength="25">
          </i-input><br><br>
          <Button @click="createUrl" :disabled="refInputError !== '' || linkId === ''" size="large" type="primary">{{ $text.tr('СОЗДАТЬ ССЫЛКУ') }}</Button>
        </div>
    <div class="box symbbox linkslist" style="margin-bottom: 15px; text-align: left; height: 100%">

      <table class="ref-table">
        <caption style="text-align: center; font-size: 18px; color: var(--color-text-dark);">{{ $text.tr('РЕФЕРАЛЬНЫЕ ССЫЛКИ') }}</caption>
        <br>
        <tr>
          <th class="ref-table-header">{{ $text.tr('ССЫЛКА') }}</th>
          <th class="ref-table-header">{{ $text.tr('ОПИСАНИЕ') }}</th>
          <th class="ref-table-header">{{ $text.tr('ПЕРЕХОДЫ') }}</th>
          <th class="ref-table-header">{{ $text.tr('РЕФЕРАЛЫ') }}</th>
          <th class="ref-table-header">{{ $text.tr('КОНВЕРСИЯ') }}</th>
          <th class="ref-table-header">{{ $text.tr('ДОХОД') }}</th>
          <th class="ref-table-header"></th>
        </tr>
        <template v-for="(reflink, index) in list">
        <tr class="tablerow" :class="{'oddrow': index % 2 === 0}" :key="reflink.Id">
          <td class="ref-table-row">
            <Icon  @click="copyToBuffer(reflink.Id)" color="gray" style="cursor: pointer;"
                   :title="$text.tr('Скопировать ссылку')" type="ios-copy-outline" size="22"></Icon>
            &nbsp;{{ baseUrl }}{{ reflink.Id }}</td>
          <td class="ref-table-row">{{ reflink.Info }}</td>
          <td class="ref-table-row">{{ reflink.Visitors }}</td>
          <td class="ref-table-row">{{ reflink.Refs }}</td>
          <td class="ref-table-row">{{ calculateConversion(reflink.Visitors, reflink.Refs) }}%</td>
          <td class="ref-table-row">${{ reflink.Income }}</td>
          <td class="ref-table-row">
            <Icon  v-if="reflink.Refs === 0" @click="showDeleteConfirm(reflink.Id)" color="gray" style="cursor: pointer;"
                                           :title="$text.tr('Удалить')" type="ios-trash-outline" size="22"></Icon>
          </td>
        </tr>
        </template>
        <tr>
          <td class="last-ref-table-row"></td>
          <td class="ref-table-row last-ref-table-row" style="font-size: 14px;">{{ $text.tr('ОБЩАЯ СТАТИСТИКА') }}</td>
          <td class="ref-table-row last-ref-table-row">{{ sumVisitors }}</td>
          <td class="ref-table-row last-ref-table-row">{{ sumRefs }}</td>
          <td class="ref-table-row last-ref-table-row">{{ calculateConversion(sumVisitors, sumRefs) }}%</td>
          <td class="ref-table-row last-ref-table-row">${{ this.refBalance }}</td>
          <td class="ref-table-row last-ref-table-row"></td>
        </tr>
      </table>
    </div>
  </div>
  </div>
</template>

<script>
import Api from '@/util/api'
import Constants from '@/util/constants'
import Confirm from '@/components/common/Confirm'
import Decimal from 'decimal.js'

export default {
  name: 'RefCab',
  components: { Confirm },
  data () {
    return {
      fetchRefUrlsInterval: null,
      showTooltip: false,
      deleteModal: false,
      refBalance: '0',
      list: [],
      linkId: '',
      linkDesc: '',
      refInputError: '',
      baseUrl: 'capico.app/?z=',
      confirm: {
        deleteId: ''
      }
    }
  },
  created () {
    this.createIntervals()
  },
  destroyed () {
    this.clearIntervals()
  },
  watch: {
    '$route' (to, from) {
      // console.log(to)
      if (to.name === 'refcab') {
        this.createIntervals()
      }
      if (from.name === 'refcab') {
        this.clearIntervals()
      }
    },
    'linkId': function (newVal) {
      this.checkErrs()
      if (this.linkId !== '') {
        this.showTooltip = true
      } else {
        this.showTooltip = false
      }
    },
    'linkDesc': function (newVal) {
      this.checkErrs()
    }
  },
  computed: {
    referralAgreementLink () {
      if (this.$store.state.sys.lang === 'es' || this.$store.state.sys.lang === 'en') {
        return 'referral_agreement_en.html'
      }
      return 'referral_agreement.html'
    },
    fullLink () {
      return this.baseUrl + this.linkId
    },
    sumVisitors () {
      let sumVisitors = 0
      this.list.forEach(function (link, i, arr) {
        sumVisitors = sumVisitors + link.Visitors
      })
      return sumVisitors
    },
    sumRefs () {
      let sumVisitors = 0
      this.list.forEach(function (link, i, arr) {
        sumVisitors = sumVisitors + link.Refs
      })
      return sumVisitors
    }
  },
  methods: {
    createIntervals () {
      this.fetchRefUrls()
      this.fetchRefUrlsInterval = setInterval(this.fetchRefUrls, 10000)
      // console.log('fetchRefUrls interval created')
    },
    clearIntervals () {
      clearInterval(this.fetchRefUrlsInterval)
      // console.log('fetchRefUrls interval cleared')
    },
    // codeChanged (event) {
    //   console.log(event)
    //   if (event.key === ' ') {
    //     event.preventDefault()
    //   }
    //   this.refInputError = ''
    //   this.linkId = event.target.value.toLowerCase()
    // },
    calculateConversion (visitors, refs) {
      if (visitors === 0) {
        return 0
      }
      return (refs * 100 / visitors).toFixed(1)
    },
    checkErrs () {
      if (this.linkId === '' && this.linkDesc !== '') {
        // console.log(this.linkId + this.linkDesc)
        this.refInputError = this.$text.tr('Заполните поле ссылки')
      } else if (!this.linkId.match(/^[0-9a-z_-]+$/i) && this.linkId !== '') {
        this.refInputError = this.$text.tr('Только английские буквы и цифры без пробелов')
      } else if (this.linkId.length < 3 && this.linkId !== '') {
        this.refInputError = this.$text.tr('Минимум 3 символа')
      } else {
        this.refInputError = ''
      }
    },
    createUrl () {
      Api.get('ref/create', {
        params: {
          token: this.$store.state.sys.token,
          id: this.linkId.trim(),
          desc: this.linkDesc.trim()
        }
      }).then(response => {
        if (response.status === Constants.http.OK) {
          // console.log('ok. data: ', response.data)
          if (!response.data.err) {
            this.fetchRefUrls()
            this.linkId = ''
            this.linkDesc = ''
            this.refInputError = ''
          } else {
            console.log(response.data.err)
            if (response.data.err === 'reached limit of ref links') {
              this.$Message.error(this.$text.tr('Достигнуто максимальное количество ссылок'))
            } else if (response.data.err === 'link id already exist') {
              this.refInputError = this.$text.tr('Ссылка уже существует')
            }
          }
        } else {
          console.log('error. status,data: ', status, response.data)
        }
      }).catch(error => {
        console.log(error)
      })
    },
    fetchRefUrls () {
      Api.get('ref/links', {
        params: {
          token: this.$store.state.sys.token
        }
      }).then(response => {
        if (response.status === Constants.http.OK) {
          // console.log('ok. data: ', response.data)

          if (response.data) {
            this.list = response.data
          } else {
            this.list = []
          }
          let newIncome = new Decimal(0)
          this.list.forEach((reflink) => {
            newIncome = newIncome.add(reflink.Income)
          })
          this.refBalance = newIncome.toString()
        } else {
          console.log('error. status: ', response.status)
        }
      }).catch(error => {
        console.log(error)
      })
    },
    copyToBuffer (linkId) {
      this.$copyText('https://' + this.baseUrl + linkId)
      this.$Message.info(this.$text.tr('Ссылка скопирована в буфер'))
    },
    showDeleteConfirm (id) {
      this.confirm.deleteId = id
      this.deleteModal = true
    },
    deleteLink (linkId) {
      Api.get('ref/delete', {
        params: {
          token: this.$store.state.sys.token,
          id: linkId
        }
      }).then(response => {
        if (response.status === Constants.http.OK) {
          // console.log('ok. data: ', response.data)
          this.fetchRefUrls()
        } else {
          console.log('error. status: ', response.status)
        }
      }).catch(error => {
        console.log(error)
      })
      this.deleteModal = false
    }
  }
}
</script>
